import { todayIso } from "../../lib/format";

export const emptyForm = {
  project_id: "", location_id: "", category_id: "", service_id: "", subcontractor_id: "",
  sell_price: "", buy_price: "",
  entry_date: todayIso(), quantity: "", description: "",
};

// Puantaj → Personel Ekle → geri dönüşte seçimler URL'den geri yüklenir
export const initialForm = () => {
  const sp = new URLSearchParams(window.location.search);
  return sp.get("proje") ? { ...emptyForm, project_id: sp.get("proje"), location_id: sp.get("lokasyon") || "", category_id: sp.get("kategori") || "", service_id: sp.get("hizmet") || "", entry_date: sp.get("tarih") || todayIso() } : emptyForm;
};

export const serviceVisible = (s, form) => s.category_id === form.category_id && s.status === "Aktif" && (!s.project_id || s.project_id === form.project_id) && (s.scope !== "projects" || (s.project_ids || []).includes(form.project_id));
export const categoryVisible = (c, projectId) => c.status === "Aktif" && (c.scope !== "projects" || (c.project_ids || []).includes(projectId));

// Veri giriş türleri (üst menü): ana başlıklar ada göre gruplanır — PERSONEL → personel, ATM → atm, kalanlar → ekstra temizlik
const normCat = (name) => (name || "").replace(/ı/g, "i").replace(/İ/g, "I").replace(/ç/g, "c").replace(/Ç/g, "C").replace(/ş/g, "s").replace(/Ş/g, "S").toUpperCase();
export const ENTRY_GROUPS = [
  { key: "personel", title: "Personel Hizmeti Veri Girişi", desc: "Asıl personel ve geçici personel hizmetleri (puantaj)", match: (n) => /PERSONEL/.test(n) },
  { key: "ekstra", title: "Ekstra Temizlik Hizmetleri Veri Girişi", desc: "Ekstra / tadilat / genel temizlik ve diğer hizmet-giderler", match: (n) => !/PERSONEL/.test(n) && !/\bATM\b/.test(n) },
  { key: "atm", title: "ATM Silim Hizmeti Veri Girişi", desc: "ATM silim hizmetleri — lokasyon olarak ATM seçilir", match: (n) => /\bATM\b/.test(n) },
];
export const groupOfCategory = (c) => { const n = normCat(c?.name); return ENTRY_GROUPS.find((g) => g.match(n))?.key || "ekstra"; };
export const initialGroup = () => { const g = new URLSearchParams(window.location.search).get("grup"); return ENTRY_GROUPS.some((x) => x.key === g) ? g : null; };

// Form zinciri: üst seçim değişince alt seçimler sıfırlanır
export function cascade(f, k, v, services) {
  const next = { ...f, [k]: v };
  if (k === "project_id") { next.category_id = ""; next.service_id = ""; next.location_id = ""; next.subcontractor_id = ""; }
  if (k === "category_id") { next.service_id = ""; next.location_id = ""; next.subcontractor_id = ""; }
  if (k === "service_id") {
    const svc = services.find((s) => s.id === v);
    if (svc && Array.isArray(svc.location_ids) && svc.location_ids.length > 0 && !svc.location_ids.includes(next.location_id)) { next.location_id = ""; next.subcontractor_id = ""; }
  }
  if (k === "location_id") next.subcontractor_id = "";
  return next;
}

export function locationPlaceholder(form, timesheetMode) {
  if (timesheetMode) return "Asıl personel: şube her personelin kartından gelir";
  if (!form.project_id) return "Önce proje seçin";
  if (!form.category_id) return "Önce ana başlık seçin";
  if (!form.service_id) return "Önce hizmet-gider seçin";
  return "Hizmete tanımlı lokasyonlar…";
}

export function servicePlaceholder(form) {
  if (!form.project_id) return "Önce proje seçin";
  return form.category_id ? "Seçiniz…" : "Önce ana başlık seçin";
}

// Enter: formdaki bir sonraki alana geç (textarea/buton/aranabilir seçim hariç)
export function focusNextOnEnter(e) {
  if (e.key !== "Enter" || e.ctrlKey || e.metaKey) return;
  const t = e.target;
  if (!(t instanceof HTMLElement) || t.tagName === "TEXTAREA" || t.tagName === "BUTTON" || t.closest("[data-searchable]")) return;
  const els = [...e.currentTarget.querySelectorAll("input:not([disabled]):not([type='hidden']):not([type='checkbox']), select:not([disabled]), textarea:not([disabled])")].filter((el) => el.tabIndex >= 0 && el.offsetParent !== null);
  const i = els.indexOf(t);
  if (i >= 0 && els[i + 1]) { e.preventDefault(); els[i + 1].focus(); if (els[i + 1].select) els[i + 1].select(); }
}

// yeni kayıt en üstte; fiyat farkı satırları ana kaydın hemen altında, sahipsizler en sonda
export function sortEntries(entries) {
  const byDate = (a, b) => String(b.created_at || b.entry_date || "").localeCompare(String(a.created_at || a.entry_date || ""));
  const mains = entries.filter((e) => !e.is_price_diff).sort(byDate);
  const out = [];
  for (const m of mains) {
    out.push(m);
    out.push(...entries.filter((e) => e.is_price_diff && e.parent_entry_id === m.id).sort(byDate));
  }
  out.push(...entries.filter((e) => e.is_price_diff && !mains.some((m) => m.id === e.parent_entry_id)).sort(byDate));
  return out;
}

// hakediş kilidi: proje + dönem (+ ana başlık) için hakediş faturası var mı
export const findLock = (claimLocks, { project_id, category_id, entry_date }) =>
  claimLocks.find((l) => l.project_id === project_id && l.period === (entry_date || "").slice(0, 7) && (!l.category_id || l.category_id === category_id));
